import React from 'react';
import './Product_size_table.css';
import Verify from '../../../Assets/Verify.svg';
import FOOT_LENGTH_SIZE from '../../../Assets/FOOT_LENGTH_SIZE.JPG';

export default function Product_size_table({ProductData}) {
    const sizeData = [
        { size: 19, range: '12.6 - 13.2 cm', active: false },
        { size: 20, range: '13.3 - 13.8 cm', active: false },
        { size: 21, range: '13.9 - 14.5 cm', active: false },
        { size: 22, range: '14.6 - 15.2 cm', active: false },
        { size: 23, range: '15.3 - 15.8 cm', active: false },
        { size: 24, range: '15.9 - 16.5 cm', active: false },
        { size: 25, range: '16.6 - 17.2 cm', active: false },
        { size: 26, range: '17.3 - 17.8 cm', active: false },
        { size: 27, range: '17.9 - 18.5 cm', active: false },
        { size: 28, range: '18.6 - 19.2 cm', active: false },
        { size: 29, range: '19.3 - 19.8 cm', active: false },
        { size: 30, range: '19.9 - 20.5 cm', active: false },
        { size: 31, range: '20.6 - 21.2 cm', active: false },
        { size: 32, range: '21.3 - 21.8 cm', active: false },
        { size: 33, range: '21.9 - 22.5 cm', active: true },
        { size: 34, range: '22.6 - 23.2 cm', active: true },
        { size: 35, range: '23.3 - 23.8 cm', active: true },
        { size: 36, range: '23.9 - 24.5 cm', active: true },
        { size: 37, range: '24.6 - 25.2 cm', active: true },
        { size: 38, range: '25.3 - 25.8 cm', active: true },
        { size: 39, range: '25.9 - 26.5 cm', active: true },
        { size: 40, range: '26.6 - 27.2 cm', active: true },
        { size: 41, range: '27.3 - 27.8 cm', active: true },
        { size: 42, range: '27.9 - 28.5 cm', active: true },
        { size: 43, range: '28.6 - 29.2 cm', active: true },
        { size: 44, range: '29.3 - 29.8 cm', active: false },
        { size: 45, range: '29.9 - 30.5 cm', active: false },
        { size: 46, range: '30.6 - 31.2 cm', active: false }
    ];   
    
    const hasSizeType = ProductData.productOptions.some(option => option.type === 'Talla');
    if (!hasSizeType) {
        return null; // No renderizar nada si no hay opciones de tipo "Talla"
    }

    return (
        <div className='col-12 d-flex justify-content-center' style={{ marginBottom: "50px" }}>
            <div className='Product_size_table' style={{ width: '100%', maxWidth: '690px' }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <img loading="lazy" style={{ maxWidth: "40px", paddingBottom: "20px", marginRight: "10px" }} src={Verify} alt="Verified" />
                    <div className='Product_size_table_title'>Tabla de Tallas</div>
                </div>
                
                <table style={{ width: '100%', textAlign: 'left', marginTop: '20px', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th style={{ borderBottom: '2px solid #000', padding: '10px 0' }}>Talla {"\uD83C\uDDE8\uD83C\uDDF4"}</th>
                            <th style={{ borderBottom: '2px solid #000', padding: '10px 0' }}>Largo del pie</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sizeData.filter(i=>i.active === true).map((item, index) => (
                            <tr key={index}>
                                <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd' }}>{item.size}</td>
                                <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd' }}>{item.range}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div>
                    {/* <div>
                        <strong>Cómo tomar tus medidas corporales</strong>
                    </div> */}
                    <div className='d-flex align-items-center' style={{marginTop:"20px"}}>
                        <img loading="lazy" src={FOOT_LENGTH_SIZE} style={{maxWidth:"100px"}} />
                        <div style={{marginLeft:"20px"}}>
                            <div>
                                <strong>Largo del pie</strong>
                                <p style={{fontSize:"15px"}}>Sobre un papel, dibuja el contorno de tus pies descalzos. Mide desde el dedo más largo hasta la altura del talón. <strong>Súmale 0.5 cm de holgura.</strong></p>
                            </div>
                        </div>
                    </div>
                </div>
                <span style={{fontSize:"10px"}}>Las medidas son para tallas colombianas, son aproximadas y pueden variar ligeramente</span>

                {/* <div style={{ border: "2px solid black", borderRadius: "15px", padding: "5px 10px", textAlign: "center", marginTop: "20px", cursor: "pointer" }}>Califica tu experiencia</div> */}
            </div>
        </div>
    );
}


// import React from 'react'
// import './Product_size_match.css';

// export default function Product_size_match() {
//     const sizeData = [
//         { label: 'Chico', value: 0 },
//         { label: 'Algo chico', value: 1 },
//         { label: 'Como esperaba', value: 10 },
//         { label: 'Algo grande', value: 0 },
//         { label: 'Grande', value: 0 }
//     ];

//     // Calculando el total de respuestas
//     const totalCount = sizeData.reduce((total, item) => total + item.value, 0);
//     // Encontrando el valor para 'Como esperaba'
//     const expectedValue = sizeData.find(item => item.label === 'Como esperaba').value;
//     // Calculando el porcentaje para 'Como esperaba'
//     const expectedPercentage = totalCount > 0 ? (expectedValue / totalCount * 100).toFixed(0) : 0;
//     // Máximo valor para establecer el ancho relativo de las barras
//     const maxCount = Math.max(...sizeData.map(item => item.value));

//     return (
//       <div className='col-12 d-flex justify-content-center' style={{marginBottom:"50px"}}>
//         <div className='Product_size_match' style={{ width: '100%', maxWidth: '690px' }}>
//           <div className='Product_title'>Al {expectedPercentage}% le quedó como esperaba</div>
//           {sizeData.map((item, index) => (
//             <div key={index} style={{ margin: '10px 0' }}>
//               <div style={{ fontSize: '0.9rem', marginBottom: '1px', fontWeight:"bolder" }}>{item.label}</div>
//               <div style={{display:"flex", }}>
//                 <div style={{ backgroundColor: '#f0f0f0', height: '20px', minWidth: '90%', maxWidth:"90%", borderRadius:"10px"  }}>
//                     <div style={{backgroundColor: '#007bff',height: '20px',width: `${item.value / maxCount * 100}%`,borderRadius:"10px"}}></div>
//                 </div>
//                 <div style={{ color: 'black', marginLeft:"5px", fontWeight:"bolder" }}>
//                     {item.value}
//                 </div>
//               </div>
//             </div>
//           ))}
//           <div>Segun {totalCount} clientes</div>
//         </div>
//       </div>
//     );
// }
